export default {
  data() {
    return {
      routerViewObserver: null,
      pendingFocus: false,
    };
  },
  methods: {
    handleKeyboardNavigation() {
      this.pendingFocus = true;
    },

    // Observe router-view DOM changes
    observeRouterView() {
      const container = document.querySelector('#breadcrumbsId');

      if (!container) return;

      // Disconnect previous observer if any
      this.disconnectObserver();

      this.routerViewObserver = new MutationObserver(() => {
        if (!this.pendingFocus) return;

        const focused = this.focusFirstElementInBreadcrumbs();
        if (focused) {
          this.pendingFocus = false;
          this.disconnectObserver();
        }
      });

      this.routerViewObserver.observe(container, {
        childList: true,
        subtree: true,
      });
    },

    disconnectObserver() {
      if (this.routerViewObserver) {
        this.routerViewObserver.disconnect();
        this.routerViewObserver = null;
      }
    },

    focusFirstElementInBreadcrumbs() {
      const container = document.querySelector('#breadcrumbsId');

      if (!container) return false;

      const firstFocusable = container.querySelector('a[href]');

      if (firstFocusable) {
        firstFocusable.focus();
        return true;
      }

      return false;
    },
  },

  watch: {
    $route() {
      if (!this.pendingFocus) return;

      this.$nextTick(() => {
        if (this.focusFirstElementInBreadcrumbs()) {
          this.pendingFocus = false;
        } else {
          this.observeRouterView();
        }
      });
    },
  },

  beforeDestroy() {
    this.disconnectObserver();
  },
};
